import { getMessaging, getToken, isSupported } from 'firebase/messaging'

import { api } from '@/api/client'
import { firebaseApp } from './firebase'

/**
 * Tarayıcı bildirimleri.
 *
 * Firebase uygulaması services/firebase.ts'te TEK örnek olarak kuruluyor
 * ve analitikle paylaşılıyor: iki modül ayrı ayrı initializeApp
 * çağırsaydı Firebase ikincisinde hata verirdi.
 */
/**
 * Web Push sertifikası (VAPID) — Firebase konsolundan geliyor:
 * Proje ayarları → Cloud Messaging → Web Push certificates.
 *
 * Yapılandırmanın aksine BU bir derleme parametresi: anahtar çifti
 * yenilenebiliyor ve yenilendiğinde kodun değişmemesi gerekiyor.
 */
const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY as string | undefined

/** Tarayıcı kimliği — sunucu cihazı bununla tanıyor. */
function installId(): string {
  let id = localStorage.getItem('nakito.install_id')
  if (!id) {
    id = crypto.randomUUID()
    localStorage.setItem('nakito.install_id', id)
  }
  return id
}

/**
 * Bildirim izni ister ve jetonu sunucuya kaydeder.
 *
 * GİRİŞTEN SONRA çağrılıyor, açılışta değil: hesabı olmayan birine
 * "bildirim gönderebilir miyim" diye sormak, neye izin verdiğini bilmeden
 * karar vermesini istemek olurdu. Mobilde de aynı sıra.
 *
 * SESSİZCE VAZGEÇİYOR. Tarayıcı desteklemiyorsa (Safari'nin eski
 * sürümleri, gizli sekme), kullanıcı reddettiyse ya da VAPID anahtarı
 * tanımlı değilse hiçbir şey olmuyor. Bildirim, panelin çalışması için
 * gerekli değil ve buradaki bir hata kullanıcıya gösterilecek bir şey
 * değil.
 */
export async function registerPushToken(): Promise<void> {
  try {
    if (!vapidKey) return
    if (!(await isSupported())) return
    if (!('serviceWorker' in navigator)) return
    if (Notification.permission === 'denied') return

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') return

    // Servis işçisi ZORUNLU: web push, sayfa kapalıyken de bildirim
    // teslim edebilmek için arka planda çalışan bir işçiye ihtiyaç
    // duyuyor. Kayıt burada yapılıyor ki dosya yoksa hata bu fonksiyonun
    // içinde kalsın.
    const registration = await navigator.serviceWorker.register(
      '/firebase-messaging-sw.js',
    )

    const token = await getToken(getMessaging(firebaseApp()), {
      vapidKey,
      serviceWorkerRegistration: registration,
    })
    if (!token) return

    await api.put<void>('/me/devices/token', {
      install_id: installId(),
      platform: 'web',
      fcm_token: token,
    })
  } catch (error) {
    // Log'lanıyor ama yutuluyor: "bildirimler neden gelmiyor" sorusunun
    // cevabı bir yerde yazmalı, kullanıcının ekranında değil.
    console.warn('Bildirim jetonu kaydedilemedi:', error)
  }
}
